module.exports = __webpack_public_path__ + "static/media/staff.cdf3c46f.svg";